import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppServiceService } from "../../../api/app-service.service";
import { ModalController } from "@ionic/angular";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-table-reservation',
  templateUrl: './table-reservation.page.html',
  styleUrls: ['./table-reservation.page.scss'],
})
export class TableReservationPage implements OnInit {
  @Output() onReservationSuccess: EventEmitter<any> = new EventEmitter();

  public reservationForm: FormGroup = null;

  public restaurantList: any[] = [];
  public isRestaurantLoading: boolean = false;
  public tableReservationInProgress: boolean = false;
  public reservationFailedMessage: string = '';
  public isUserDetailsLoading: boolean = false;
  public todayDate: string = '';

  constructor(public appService: AppServiceService, public modalController: ModalController, private translateService: TranslateService) {

    // get current date to set to date input min value
    let dateNow = new Date();
    this.todayDate = dateNow.getFullYear() + '-' + (dateNow.getMonth() + 1).toString().padStart(2, "0") + '-' + dateNow.getDate();

    // form validation configurations
    this.reservationForm = new FormGroup({
      restaurant: new FormControl('', {
        validators: [
          Validators.required
        ],
        updateOn: 'change'
      }),
      reservation_date: new FormControl('', {
        validators: [
          Validators.required
        ],
        updateOn: 'change'
      }),
      reservation_time: new FormControl('', {
        validators: [
          Validators.required
        ],
        updateOn: 'change'
      }),
      number_of_person: new FormControl('', {
        validators: [
          Validators.required,
          Validators.min(1),
          Validators.max(20)
        ],
        updateOn: 'change'
      }),
      name: new FormControl('', {
        validators: [
          Validators.required,
          Validators.pattern(/\w+\s\w+/)
        ],
        updateOn: 'change'
      }),
      email: new FormControl('', {
        validators: [
          Validators.required,
          // Validators.pattern("^([\\w\\.\\-]+)@([\\w\\-]+)((\\.(\\w){2,3})+)$"),
          Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"),
        ],
        updateOn: 'change'
      }),
      mobile_number: new FormControl('', {
        validators: [Validators.required,
        Validators.minLength(9),
        Validators.maxLength(30),
        Validators.pattern(/(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))/)],
        updateOn: 'change'
      }),
      special_note: new FormControl('', {
        validators: [
          // Validators.required
        ],
        updateOn: 'change'
      })
    });
  }

  ngOnInit() {
    this.fetchRestaurants();

    if (this.appService.appObject.isAuthed) {
      // fetch user details if user logged into the account
      // and fill the inputs
      this.isUserDetailsLoading = true;
      this.appService.getUserDetails({ customer_id: this.appService.appObject.userId }).then(data => {
        if (data.status) {
          this.reservationForm.get('name').setValue(data.data.first_name + (data.data.last_name ? ' ' + data.data.last_name : ''));
          this.reservationForm.get('email').setValue(data.data.email);
          this.reservationForm.get('mobile_number').setValue(data.data.mobile_number);
        }
        this.isUserDetailsLoading = false;

      }, error => {
        this.isUserDetailsLoading = false;
      });
    } else {
      console.log('not authed');
    }
  }


  async dismiss() {
    // console.log(this.appService.hideCartButton);
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  /**
   * Validate email address 
   */
  emailvalidation() {
    if (this.reservationForm.value.email) {
      this.reservationForm.get('email').setValue(this.reservationForm.value.email.trim());
    }
  }

  /**
   * Fetch all restaurant branches
   */
  fetchRestaurants() {
    this.isRestaurantLoading = true;
    this.restaurantList = [];
    this.appService.fetchRestaurantListForTableReservation().then((response: any) => {
      // console.log('Restaurents : ', response);
      this.isRestaurantLoading = false;
      if (response.status && response.data && response.data.length) {
        this.restaurantList = response.data;

        // set main branch as default value
        let defaultRestaurant = this.restaurantList.find((restaurant) => restaurant.is_main === 'true');
        if (defaultRestaurant) this.reservationForm.get('restaurant').setValue(defaultRestaurant);
      }
    }).catch((error) => {
      console.log('error :  ', error);
      this.isRestaurantLoading = false;
    })
    // setTimeout(() => {
    //   this.isRestaurantLoading = false;
    //   this.restaurantList = [{ name: 'Test Restaurant 1', id: 1 }, { name: 'Test Restaurant 2', id: 2 }, { name: 'Test Restaurant 3', id: 3 }];
    // }, 2500);
  }

  /**
   * Place reservation
   */
  placeReservation() {
    this.reservationForm.markAllAsTouched();

    if (this.reservationForm.valid) {
      let formData = this.reservationForm.value;
      let splitedTime = formData.reservation_time.split('T')[1].split(':');
      let reservationTime = splitedTime[0] + ':' + splitedTime[1];

      let reservationDetails = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        mobile_number: formData.mobile_number,
        special_note: formData.special_note.trim(),
        reservation_time: reservationTime,
        reservation_date: formData.reservation_time.split('T')[0],
        number_of_person: formData.number_of_person,
        restaurant_id: formData.restaurant.id
      }

      // console.log('Final Data Set : ', reservationDetails);
      this.tableReservationInProgress = true;
      // clear failed messages
      this.reservationFailedMessage = '';
      this.appService.placeTableReservation(reservationDetails).then((response: any) => {
        if (response.status) {
          // open success alert
          this.translateService.get([
            'key.reservation_request_submitted',
            'key.your_request_has_been_sent_to_restaurant',
            'key.please_note',
            'key.reservation_success_part_1',
            'key.reservation_success_part_2'
          ]).toPromise().then((response) => {

            let msgCssClass = this.appService.isWebVersion ? 'reservation-success-msg-web' : 'reservation-success-msg';
            let successMessage = "<span class=\"" + msgCssClass + "\">";

            successMessage += (response['key.your_request_has_been_sent_to_restaurant'] ? (response['key.your_request_has_been_sent_to_restaurant'] + '. ') : 'key.your_request_has_been_sent_to_restaurant' + '. ');
            successMessage += '<br>' + (response['key.please_note'] ? ('<strong>' + response['key.please_note'] + ' : </strong>') : '<strong>key.please_note :</strong>');
            successMessage += (response['key.reservation_success_part_1'] ? (response['key.reservation_success_part_1'] + ' ') : 'key.reservation_success_part_1 ');
            successMessage += '<strong>' + formData.restaurant.name + '</strong> '
            successMessage += (response['key.reservation_success_part_1'] ? response['key.reservation_success_part_2'] : 'key.reservation_success_part_2');
            successMessage += '.';

            if (!this.appService.isWebVersion) {
              // close reservation form
              this.dismiss();
              this.appService.showAlert('reservation-success', response['key.reservation_request_submitted'] ? response['key.reservation_request_submitted'] : 'key.reservation_request_submitted', successMessage, false);
            } else {
              this.onReservationSuccess.emit([successMessage]);
            }
          });

        } else if (response.msg && response.msg.msg && response.msg.msg.length) {
          this.reservationFailedMessage = response.msg.msg[0];
        }
        this.tableReservationInProgress = false;
      }).catch((error) => {
        console.log('error: ', error);
        this.tableReservationInProgress = false;
      })
    } else {
      console.log('Final Data Set : Invalid Form');
    }
  }
}
